import {
  FETCH_ADMIN_DETAILS,
  FETCH_ALERT_DETAILS,
  FETCH_CONTENT_DETAILS,
  FETCH_NOTIFICATION_DETAILS,
  FETCH_NOTIFICATION_USERS,
  FETCH_USER_DETAILS,
  LOAD_ADMIN_DETAILS,
  LOAD_ALERT_DETAILS,
  LOAD_CONTENT_DETAILS,
  LOAD_NOTIFICATION_DETAILS,
  LOAD_NOTIFICATION_USERS,
  LOAD_USER_DETAILS,
  RESET_NOTIFICATION_DETAILS
} from '../Actions/Details'

/**
  * DetailsReducer
  * @desc Details state data handler
  * @param {Object} state
  * @param {action} action
  * @return {Object} state updated state
*/
export default function DetailsReducer (state, action) {
  const loadingUser = {
    users: [{
      _id: 'none',
      name: 'Loading',
      regCode: '',
      email: ''
    }],
    count: 0
  }

  if (typeof state === 'undefined') {
    return {
      admin: {
        title: 'Loading'
      },
      user: {
        title: 'Loading'
      },
      content: {
        title: 'Loading'
      },
      alert: {
        title: 'Loading'
      },
      notification: {
        title: 'Loading'
      },
      notificationUsers: loadingUser
    }
  }

  switch (action.type) {
    case FETCH_USER_DETAILS:
      return Object.assign({}, state, { user: { title: 'Loading' } })
    case LOAD_USER_DETAILS:
      return Object.assign({}, state, { user: action.data.getUserDetails })
    case FETCH_NOTIFICATION_DETAILS:
      return Object.assign({}, state, { notification: { title: 'Loading' } })
    case LOAD_NOTIFICATION_DETAILS:
      return Object.assign({}, state, { notification: action.data.getNotificationDetails })
    case FETCH_CONTENT_DETAILS:
      return Object.assign({}, state, { content: { title: 'Loading' } })
    case FETCH_ALERT_DETAILS:
      return Object.assign({}, state, { content: { title: 'Loading' } })
    case LOAD_CONTENT_DETAILS:
      return Object.assign({}, state, { content: action.data.contentSummary })
    case LOAD_ALERT_DETAILS:
      return Object.assign({}, state, { alert: action.data.alertSummary })
    case FETCH_ADMIN_DETAILS:
      return Object.assign({}, state, { admin: { title: 'Loading' } })
    case LOAD_ADMIN_DETAILS:
      return Object.assign({}, state, { admin: action.data.getAdminDetails })
    case FETCH_NOTIFICATION_USERS:
      return Object.assign({}, state, { notificationUsers: loadingUser })
    case LOAD_NOTIFICATION_USERS:
      return Object.assign({}, state, { notificationUsers: action.data.getNotificationUsers })
    case RESET_NOTIFICATION_DETAILS:
      return Object.assign({}, state, { notification: { title: 'Loading' } })
    default:
      return state
  }
}
